module.exports = __webpack_public_path__ + "img/banner_mobile.58e83c88.png";